import { type GridRenderEditCellParams } from '@mui/x-data-grid-pro'
import { useState } from 'react'
import { type TEditableSpecimen } from '../../../../schema/specimen'
import MutationMarkSelectorModal from '@/components/MutationMarkSelectorModal'
import EditIcon from '@mui/icons-material/Edit'
import IconButton from '@mui/material/IconButton'
import Box from '@mui/material/Box'
import { getMutationMarkLabel } from '../../../../utils/mutationMark'

const MutationMarkSelectorModalContainer = (
  props: GridRenderEditCellParams<TEditableSpecimen>
) => {
  const { row, api } = props
  const [modalOpened, setModalOpened] = useState(false)

  const handleSave = (updatedRow: TEditableSpecimen) => {
    api.updateRows([updatedRow])
  }

  return (
    <>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
        }}
      >
        {getMutationMarkLabel(row.mutationMark)}
        <IconButton color="primary" onClick={() => setModalOpened(true)}>
          <EditIcon />
        </IconButton>
      </Box>
      {modalOpened && (
        <MutationMarkSelectorModal
          value={row.mutationMark}
          open={modalOpened}
          onClose={() => setModalOpened(false)}
          onSave={(mutationMark) => handleSave({ ...row, mutationMark })}
        />
      )}
    </>
  )
}

export default MutationMarkSelectorModalContainer
